import { ImgHTMLAttributes, useEffect, useState } from "react";

interface ProgressiveImageTypes extends ImgHTMLAttributes<HTMLImageElement> {
    src: string,
    placeholder: string,
    alt: string,
}

// class ProgressiveImage extends Component {
//   static defaultProps = {
//     alt: ""
//   };

//   constructor(props:ProgressiveImageTypes) {
//     super(props);
//     // initially set loading to true and current src of image to placeholder image
//     this.state = {
//       loading: true,
//       currentSrc: props.placeholder
//     };
//   }

//   componentDidMount() {
//     const { src } = this.props;
//     // start loading original image
//     const imageToLoad = new Image();
//     imageToLoad.src = src;
//     imageToLoad.onload = () =>
//       // When image is loaded replace the image's src and set loading to false
//       this.setState({ currentSrc: src, loading: false });
//   }

//   render() {
//     const { currentSrc, loading } = this.state;
//     const { alt } = this.props;
//     return (
//       <img
//         src={currentSrc}
//         className="ProgressiveImage"
//         style={{
//           opacity: loading ? 0.5 : 1,
//           transition: "opacity .15s linear"
//         }}
//         alt={alt}
//       />
//     );
//   }
// }



export default function ProgressiveImageLoader({src, placeholder,alt, ...rest}:ProgressiveImageTypes){

    const [loading, setLoading] = useState(true)
    const [currentSrc, setCurrentSrc] = useState(placeholder)

    useEffect(()=>{

        const imageToLoad = new Image()
        imageToLoad.src = src
        imageToLoad.onload = ()=>{
            setCurrentSrc(src)
            setLoading(false)
        }
        
    },[src])

    return(
        <img
            {...rest}
            style={{
                filter: loading ? "blur(4px)" : "blur(0)",
                transition: "-webkit-filter .15s linear",
                overflow: "hidden"
            }}
            src={currentSrc}
            alt={alt}
        />
    )

}